import { IconProps } from ".";

export const LockClosedIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="4 4 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <path
        d="M6.698 20.1062C6.698 23.1422 8.59802 25.2942 11.6447 25.2942H20.3607C23.4087 25.2942 25.2981 23.1422 25.2981 20.1062V11.8915C25.2981 8.84486 23.4087 6.69287 20.3607 6.69287H11.6447C8.60736 6.69287 6.698 8.84486 6.698 11.8915V20.1062Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M19.1844 27.9862V25.2915M12.8203 27.9862V25.2915"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M6.69467 19.1725H4M6.69467 12.8179H4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M28.0022 19.1725H25.2969M28.0022 12.8179H25.2969"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M19.1844 6.69467V4M12.8203 6.69467V4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8457 20.6123H14.1537C13.1417 20.6123 12.323 19.7923 12.323 18.7803V16.707C12.323 15.695 13.1417 14.875 14.1537 14.875H17.8457C18.8577 14.875 19.6777 15.695 19.6777 16.707V18.7803C19.6777 19.7923 18.8577 20.6123 17.8457 20.6123Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M18.2035 14.9152V13.5526C18.1889 12.3339 17.1889 11.3605 15.9729 11.3752C14.7809 11.3912 13.8169 12.3498 13.7969 13.5418V14.9152"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
